/* Content is never hidden while waiting for script execution or intersection. */
(() => {
  'use strict';
  if (window.SleepitiMotion) return;
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (motionQuery.matches) return;
      entry.target.classList.add('sl-revealing');
      entry.target.addEventListener('animationend', () => entry.target.classList.remove('sl-revealing'), { once: true });
    });
  }, { threshold: 0.12 }) : null;

  function init(root = document) {
    if (!observer || motionQuery.matches || window.Shopify?.designMode) return;
    root.querySelectorAll('.sleepiti [data-sl-reveal]').forEach((element) => {
      if (observed.has(element)) return;
      observed.add(element);
      observer.observe(element);
    });
  }
  function closeMenus(except) {
    document.querySelectorAll('.sleepiti .sl-nav-group[open], .sleepiti .sl-mobile-menu[open]').forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const menu = event.target.closest('.sl-nav-group, .sl-mobile-menu');
    closeMenus(menu);
    if (menu && event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const activeMenu = document.activeElement?.closest('.sleepiti .sl-nav-group[open], .sleepiti .sl-mobile-menu[open]');
    closeMenus();
    activeMenu?.querySelector('summary')?.focus();
  });
  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element) closeMenus(event.target.closest('.sl-nav-group, .sl-mobile-menu'));
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sl-reveal]').forEach((element) => observer?.unobserve(element));
  });
  const handleMotionChange = () => {
    if (!motionQuery.matches) { init(); return; }
    document.querySelectorAll('.sleepiti .sl-revealing').forEach((element) => element.classList.remove('sl-revealing'));
  };
  motionQuery.addEventListener?.('change', handleMotionChange);
  window.SleepitiMotion = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
